var Backbone = require('backbone'),
    _ = require('underscore'),
    fvChannel = require('glRadio').channel('FV'),
    Util = require('../../../FV/util.js');


module.exports = Backbone.Model.extend({

    widthStorageKey: null,

    minWidth: 50, // if open -- must be at least this wide (px); assuming not closed

    defaults: {
        subPanes: [],  //names of: perhaps a hashView the name and the view object?
        currentSubPane: null, //trigger subpane opening/closing (null indicates the panel is closed)
        lastOpenSubPane: null,
        isOpen: false,
        isCovering: false, //flag -- set to true if open to entire container width
        width: null, //default 'openToValue' -- of center content and side pane views
        lastOpenWidth: null, //set on update width
        defaultSubPane: null //the default subPanel is the one the app will open to by default
    },

    initialize: function() {

        var loadWidth = this._getWidthOnLoad();
        this.updateWidth(loadWidth);
        this._updateStorageWidth(loadWidth); //(lister not set yet -- do it?)

    },

    // Open the panel and set the given subpane as active
    // Entry point to open to it.
    openToSubPane: function(subPane, options) {

        var isOpen = this.isOpen(),
            changingSubPane = subPane !== this.get('currentSubPane'),
            isCovering = ( options && options.cover ) || ( this.isCovering() ), //(entering into with cover or subpane change when covering)
            openToSubPane = subPane === 'default' ? this.get('defaultSubPane') : subPane,
            preCloseAttrs,
            attrs = {
                isCovering: isCovering ? true : false,
                isOpen: true,
                currentSubPane: openToSubPane,
                lastOpenSubPane: openToSubPane,
                lastOpenWidth: this.get('width') ? this.get('width') : this.previous('lastOpenWidth')//this.previous('lastOpenWidth') //don't think need
            };

        isCovering && (preCloseAttrs = _.extend({}, attrs));
        (options && options.forceOpen && this.get('isOpen')) && this.close();

        if (isCovering) {

            this.set({width:  options.containerWidth}, {silent: true});

            if (changingSubPane) {
                preCloseAttrs.lastOpenWidth = this.get('lastOpenWidth'); //could set in above but now overriding here
            } else {
                this._updateStorageWidth( this.get('lastOpenWidth') );
            }

            this.set(preCloseAttrs, options);

        } else {

            var lastOpenWidth = this.get('lastOpenWidth'),
                w = Math.max(lastOpenWidth, this.minWidth);

            this.set('width', w, {silent: true}); //no trigger
            this._updateStorageWidth(w);
            this.set(attrs, options); //last open width incorrect here after the first open cover
        }
    },
    updateWidth: function(width, options)  {

        this.set({
            width: width,
            lastOpenWidth: width
        }, options);

        this._updateStorageWidth(width);

    },

    _updateStorageWidth: function(value) {
        fvChannel.request('localStorage').setItem(  _.result(this, 'widthStorageKey'), value );
    },

    /*
    * If the width isn't stored in local storage or its value is null, get it from the style sheet, otherwise use the stored value.
    * This may be better performed on init of the localStorage module in a config variable.
    * */

    _getWidthOnLoad: function() {

        var locallyStoredValue = fvChannel.request('localStorage').getItem( _.result(this, 'widthStorageKey') );

        //null will be string; this happens if closed w/the collapser -- still????
        return (!locallyStoredValue || locallyStoredValue === 'null' || isNaN(locallyStoredValue))
            ? getOriginalWidthFromStyleSheet.call(this)
            : parseInt(locallyStoredValue);

        // TODO: remove the stylesheet dependency -- calc from the JS
        // Note: needs the FV namespace
        function getOriginalWidthFromStyleSheet() {
            return parseInt(
                Util.getStyleSheetPropertyValue('.FV .FV-side-' + this.get('side'), 'width')
            );
        }

    },

    hasSubPane: function(strPane) {
        return _.contains(this.get('subPanes'), strPane);
    },
    isActivePane: function(subPane) { //return if the given subpanel is the active one
        return (this.get('currentSubPane') === subPane);
    },
    isSubPanelOpen: function(subPane) { //is the panel open to the given subPane?
        return (this.get('isOpen') === true && this.get('currentSubPane') === subPane);
    },
    isOpen: function() {
        return this.get('isOpen');
    },
    close: function() {
        this.doClose();
    },
    isCovering: function() {
      return this.get('isCovering');
    },

    //(close entire panel)
    doClose: function() {

        this.set({
            isCovering: false,
            isOpen: false, //trigger
            width: null, //trigger
            currentSubPane: null,  //trigger
            lastOpenSubPane: this.previous('currentSubPane')
        });

    },
    destroy: function() {
        this.stopListening();
    }
});







/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/layout/panelCommon/models/sidePane.js
 ** module id = 756
 ** module chunks = 0
 **/